/* eslint-disable import/no-unresolved */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */

const imageZoom = (constants) => {
    const docBody = $(document.body);

    if ($('.product-detail').length) {
        docBody.find('.product-detail .primary-images .image-zoom.zoom-lens-enabled').on('mousemove', (e) => {
            const zoomer = e.currentTarget;
            const thisTarget = $(zoomer);

            if (thisTarget.css('background-image') === 'none') {
                thisTarget.css('background-image', `url(${thisTarget.data('background')})`);
            }

            if (window.outerWidth >= constants.viewport_bootstrap.lg) {
                e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
                e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
                x = offsetX / zoomer.offsetWidth * 100;
                y = offsetY / zoomer.offsetHeight * 100;
                zoomer.style.backgroundPosition = `${x}% ${y}%`;
            }
        });
    }
};

module.exports = {
    imageZoom,
};
